import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('bringozTimeHHMM', bringozTimeHHMM);

function bringozTimeHHMM() {
  return function bringozTimeHHMMFilter(timeInMillis) {
    if (!timeInMillis) {
      return '---';
    }

    const totalSeconds = Math.floor(timeInMillis / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
  }
}
